import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { DialogService, type DynamicDialogConfig } from 'primeng/dynamicdialog';
import {
  GdprModalComponent,
  type GdprModalData
} from '../components/gdpr-modal/gdpr-modal.component';
import { UserService } from '../services/user.service';
import { TranslateService } from '@ngx-translate/core';

/**
 * Prevents accessing a route until GDPR is accepted
 */
export const gdprGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const dialogService = inject(DialogService);
  const translateService = inject(TranslateService);

  const countryCode = userService.getCountryCode()?.toLowerCase();

  if (countryCode !== 'nl') return true;

  return new Promise((resolve) => {
    const ref = dialogService.open(GdprModalComponent, {
      header: translateService.instant('GDPR.DataProtection'),
      modal: true,
      width: '700px',
      data: {
        countryCode
      }
    } as DynamicDialogConfig<GdprModalData>);

    if (!ref) {
      resolve(false);
      return;
    }

    ref.onClose.subscribe((res: boolean) => {
      resolve(res ?? false);
    });
  });
};
